import {
  ClientIcon,
  CouponIcon,
  CustomerIcon,
  HomeIcon,
  ManagementIcon,
  ReservationIcon,
  SalesIcon,
  StaffIcon,
} from "../icon";

/////////////////////////////////////////////////////////////////////////
// List Item 추가 방법
//   - label은 필수
//   - icon, activeIcon은 컴포넌트 형식으로
//   - dropdown일 경우 children: [ {icon: activeIcon: label: } ] 형식으로
/////////////////////////////////////////////////////////////////////////
export const assignKeysToItems = (items, prefix = "") =>
  items.map((item, idx) => {
    const key = item.key ?? `${prefix}${idx}`;
    return {
      ...item,
      key,
      children: item.children
        ? assignKeysToItems(item.children, `${key}-`)
        : undefined,
    };
  });

export const hasChildSelected = (children, selectedKey) => {
  if (!Array.isArray(children)) return false;

  return children.some(
    (child) =>
      child.key === selectedKey ||
      hasChildSelected(child.children, selectedKey),
  );
};

const SideBarItemList = [
  {
    key: "home",
    icon: HomeIcon,
    link: "/home",
    label: "Home",
  },
  {
    key: "club",
    icon: ManagementIcon,
    label: "Management",
    children: [
      { label: "Club information", link: "/golf-info" },
      { label: "Course info", link: "/course-list" },
      { label: "Tee time", link: "/tee-time" },
      { label: "Pricing", link: "/price-list" },
      { label: "Charges", link: "/charge-list" },
    ],
  },
  {
    key: "reservation",
    icon: ReservationIcon,
    label: "Reservation",
    children: [
      { label: "Insights", link: "/insights" },
      { label: "Open Schedule", link: "/price-schedule" },
      { label: "Tee time table", link: "/reservation-table" },
      { label: "Reservation list", link: "/reservation" },
    ],
  },
  {
    key: "coupons",
    icon: CouponIcon,
    label: "Coupons",
    children: [
      { label: "Coupons Management", link: "/coupons" },
      { label: "History", link: "/coupon-history" },
    ],
  },
  {
    key: "sales",
    icon: SalesIcon,
    label: "Sales",
    children: [
      { label: "Sales analytics", link: "/sales" },
      { label: "Sales details", link: "/sales-detail" },
      // { label: "Sales settlement", link: "/reservation-table" },
    ],
  },
  {
    key: "membership",
    icon: CustomerIcon,
    label: "Customer",
    children: [
      { label: "Membership tiers", link: "/membership-tiers" },
      { label: "Customer list", link: "/customer-list" },
    ],
  },

  {
    key: "staff",
    icon: StaffIcon,
    label: "Staff",
    children: [
      { label: "Permissions", link: "/setting-role" },
      { label: "Staff list", link: "/staff" },
    ],
  },

  {
    key: "staffAll",
    icon: StaffIcon,
    label: "Staff",
    children: [{ label: "Staff list", link: "/staff-all" }],
  },

  {
    key: "client",
    icon: ClientIcon,
    link: "/client",
    label: "Client list",
    children: [],
  },
];

export { SideBarItemList };
